import React from "react";
import {
  Col,
  Image,
  Row,
} from "antd";
import BillingLogo from "../../assets/images/billing.webp";

const GstBills = () => {
  return (
    <React.Fragment>
      <Col span={24} className="mt-[50px] mb-[50px]">
        <Row>
          <Col span={12}>
            <Image src={BillingLogo} height={480} preview={false} />
          </Col>
          <Col span={12} className="mt-6">
            <h1 className="text-start leading-tight text-[#314259] text-[48px] font-extrabold">
              Create GST Bills for customers and share them online
            </h1>
            <p className="mt-6 text-start text-[#787878] text-[20px] font-semibold">
              Mbook billing software helps you set up a professional brand
              identity with useful GST billing features. You can use Mbook
              accounting and billing app to create invoices. It helps you comply
              with Goods and Service Tax law in India.{" "}
            </p>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
export default GstBills;
